var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1150 512L1150 540",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1150.5,
    cy: 507.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.1 516C1146.64 516 1146.24 515.834 1145.9 515.501C1145.57 515.168 1145.4 514.768 1145.4 514.3C1145.4 513.833 1145.57 513.432 1145.9 513.099C1146.24 512.766 1146.64 512.6 1147.1 512.6C1147.57 512.6 1147.97 512.766 1148.31 513.099C1148.64 513.432 1148.81 513.833 1148.81 514.3C1148.81 514.768 1148.64 515.168 1148.31 515.501C1147.97 515.834 1147.57 516 1147.1 516ZM1155.61 516C1155.14 516 1154.74 515.834 1154.41 515.501C1154.08 515.168 1153.91 514.768 1153.91 514.3C1153.91 513.833 1154.08 513.432 1154.41 513.099C1154.74 512.766 1155.14 512.6 1155.61 512.6C1156.08 512.6 1156.48 512.766 1156.81 513.099C1157.15 513.432 1157.31 513.833 1157.31 514.3C1157.31 514.768 1157.15 515.168 1156.81 515.501C1156.48 515.834 1156.08 516 1155.61 516ZM1146.38 502.4L1148.42 506.65H1154.38L1156.72 502.4H1146.38ZM1145.57 500.7H1158.12C1158.45 500.7 1158.7 500.845 1158.87 501.136C1159.04 501.426 1159.04 501.72 1158.89 502.018L1155.87 507.457C1155.71 507.741 1155.5 507.96 1155.24 508.116C1154.98 508.272 1154.69 508.35 1154.38 508.35H1148.04L1147.1 510.05H1157.31V511.75H1147.1C1146.47 511.75 1145.98 511.47 1145.66 510.911C1145.33 510.351 1145.32 509.795 1145.62 509.242L1146.76 507.16L1143.7 500.7H1142V499H1144.77L1145.57 500.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping2);
export default __webpack_public_path__ + "static/media/shopping_2.d9b47473c52d38608f2e1551cfbe0138.svg";
export { ForwardRef as ReactComponent };